import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { GET_CONFIGURATION } from '../../../graphql/configuration/queries/get-configuration';
import { IConfigurationSettingsProps } from './configuration-settings.models';
import {
  setIsLocatorIconsCampaign,
  setIsCaptcha,
  setC2CMode,
  setIsVideoCall,
  setMyopiaControl,
  setMms,
  setAllowedStoreGroupCodes,
  setIsPhoneCallConsent,
  setIsRuStore,
} from '../../../graphql/configuration/configuration.cache';
import {
  getLocatorIconsEnabled,
  getCaptchaEnabled,
  getC2CMode,
  getVideoCallEnabled,
  getMyopiaControlEnabled,
  getMmsEnabled,
  getAllowedGroupCodes,
  getRuStoreEnabled,
} from './utils';
import { setOrderModalToStorage } from '../../../utils/order/set-orders-status-to-storage';
import { getPhoneCall } from './utils/get-phone-call-consent';

export const ConfigurationSettings = ({ children }: IConfigurationSettingsProps): JSX.Element => {
  const { data } = useQuery(GET_CONFIGURATION, {
    context: { clientName: 'anonymous' },
  });

  useEffect(() => {
    if (data?.configuration?.length) {
      setIsLocatorIconsCampaign(getLocatorIconsEnabled(data.configuration));
      setIsCaptcha(getCaptchaEnabled(data.configuration));
      setC2CMode(getC2CMode(data.configuration));
      setOrderModalToStorage(getC2CMode(data.configuration));
      setIsVideoCall(getVideoCallEnabled(data.configuration));
      setMyopiaControl(getMyopiaControlEnabled(data.configuration));
      setMms(getMmsEnabled(data.configuration));
      setAllowedStoreGroupCodes(getAllowedGroupCodes(data.configuration));
      setIsPhoneCallConsent(getPhoneCall(data.configuration));
      setIsRuStore(getRuStoreEnabled(data.configuration));
    }
  }, [data]);

  return children as JSX.Element;
};
